import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Loader from "../Loader/Loader";
import useApi from "../../hook/useApi";
import { toast } from "react-toastify";
import { getHeaders, isValidEVMAddress } from "../../utils/helper";
import { BASE_URL } from "../../utils/constant";
import axios from "axios";

const defaultCollection = {
     name: "",
     address: "",
     category: "",
     type: "",
     image: "",
};

const CATEGORIES = ["CATEGORY1", "CATEGORY2", "CATEGORY3"]; // Adjust based on your app's categories
const TYPES = ["TYPE1", "TYPE2", "TYPE3"]; // Adjust based on your app's types

const AddNftCollection = ({ show, handleClose, mode = "create", data = {} }) => {
     const isView = mode === "view";
     const isUpdate = mode === "update";
     const isCreate = mode === "create";

     const [formData, setFormData] = useState(defaultCollection);
     const [errors, setErrors] = useState({});
     const [loading, setLoading] = useState(false);
     const [imagePreview, setImagePreview] = useState(null);

     // Validation function
     const validate = () => {
          const newErrors = {};
          const fields = [
               { key: "name", value: formData.name },
               { key: "address", value: formData.address },
               { key: "category", value: formData.category },
               { key: "type", value: formData.type },
               { key: "image", value: formData.image },
          ];

          fields.forEach(({ key, value }) => {
               if (!value) {
                    newErrors[key] = `${key.charAt(0).toUpperCase() + key.slice(1)} is required`;
               } else if (key === "name" && value.length > 50) {
                    newErrors[key] = "Name must not exceed 50 characters";
               } else if (key === "address" && value.length > 100) {
                    newErrors[key] = "Address must not exceed 100 characters";
               } else if (key === "address" && !isValidEVMAddress(value)) {
                    newErrors[key] = "Invalid EVM address";
               } else if (key === "type" && !TYPES.includes(value)) {
                    newErrors[key] = "Invalid type selected";
               } else if (key === "category" && !CATEGORIES.includes(value)) {
                    newErrors[key] = "Invalid category selected";
               }
               if (newErrors[key] === "") {
                    delete newErrors[key];
               }
          });


          console.log('newErrors : ', newErrors)

          setErrors(newErrors);
          return Object.keys(newErrors).length === 0;
     };

     console.log('errors : ', errors)

     // Populate form data when modal opens
     useEffect(() => {
          if (show && (isUpdate || isView)) {
               setFormData({
                    ...defaultCollection,
                    ...data,
                    image: data?.image || "",
               });
               setImagePreview(`${BASE_URL}/uploads/${data?.image}` || null);
          } else if (isCreate) {
               setFormData(defaultCollection);
               setImagePreview(null);
          }
          setErrors({});
     }, [show, data, mode]);

     // Handle text and select field changes
     const handleChange = (e) => {
          const { name, value } = e.target;
          setFormData((prev) => ({
               ...prev,
               [name]: value,
          }));

          // Validate field
          setErrors((prevErrors) => {
               const newErrors = { ...prevErrors };
               if (!value) {
                    newErrors[name] = `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
               } else if (name === "name" && value.length > 50) {
                    newErrors[name] = "Name must not exceed 50 characters";
               } else if (name === "address" && !isValidEVMAddress(value)) {
                    newErrors[name] = "Invalid EVM address";
               }
               else if (name === "address" && value.length > 100) {
                    newErrors[name] = "Address must not exceed 100 characters";
               } else if (name === "category" && !CATEGORIES.includes(value)) {
                    newErrors[name] = "Invalid category selected";
               } else if (name === "type" && !TYPES.includes(value)) {
                    newErrors[name] = "Invalid type selected";
               } else {
                    newErrors[name] = "";
               }

               if (newErrors[name] === "") {
                    delete newErrors[name];
               }
               console.log("newErrors123 : ", newErrors)
               return newErrors;
          });
     };

     // Handle file input for image
     const handleImageChange = (e) => {
          const file = e.target.files[0];
          if (file) {
               let newErrors = { ...errors };
               const validImageTypes = ["image/png", "image/jpeg", "image/jpg"];
               if (!validImageTypes.includes(file.type)) {
                    newErrors.image = "Please upload a valid PNG, JPG, or JPEG image file";
                    setErrors(newErrors);
                    return;
               }
               else {
                    delete newErrors.image;
               }
               if (file.size > 5 * 1024 * 1024) {
                    // 5MB limit
                    newErrors.image = "Image size must not exceed 5MB";
                    setErrors(newErrors);
                    return;
               }
               else {
                    delete newErrors.image;
               }
               setFormData((prev) => ({ ...prev, image: file }));
               setImagePreview(URL.createObjectURL(file));
               setErrors(newErrors);
          }
     };

     // Handle form submission
     const handleSubmit = async () => {
          try {
               if (!validate() || Object.keys(errors).length > 0) {
                    return;
               }

               setLoading(true);

               const formDataToSend = new FormData();
               formDataToSend.append("name", formData.name);
               formDataToSend.append("address", formData.address);
               formDataToSend.append("category", formData.category);
               formDataToSend.append("type", formData.type);
               if (formData.image instanceof File) {
                    formDataToSend.append("image", formData.image);
               }
               if (isUpdate) {
                    formDataToSend.append("collectionId", data?._id);
               }

               console.log("image", formData.image)

               let result;

               if (isCreate) {
                    result = await axios.post(
                         `${BASE_URL}/collection/create`,
                         formDataToSend,
                         {
                              headers: { ...getHeaders(), "Content-Type": "multipart/form-data" },
                         }
                    );
               }
               else {
                    result = await axios.put(
                         `${BASE_URL}/collection/update`,
                         formDataToSend,
                         { headers: { ...getHeaders(), "Content-Type": "multipart/form-data" } }
                    );
               }
               console.log('result : ', result)
               if (result?.data?.success) {
                    toast.success(`Collection ${isCreate ? "created" : "updated"} successfully`);
                    handleClose(true);
               }
               else {
                    toast.error(result?.data?.message || "Something went wrong");
               }
          } catch (error) {
               console.log("error...", error);
               toast.error("An error occurred while saving collection");
          }
          finally {
               setLoading(false);
               setErrors({});
          }
     };

     // Render text or select fields
     const renderField = (label, name, type = "text", as = "input") => (
          <Form.Group className="mb-3">
               <Form.Label>{label}</Form.Label>
               <Form.Control
                    type={type}
                    as={as}
                    name={name}
                    value={formData[name] || ""}
                    onChange={handleChange}
                    readOnly={isView}
                    className={errors[name] ? "is-invalid" : ""}
                    placeholder={`Enter ${label.toLowerCase()}`}
                    maxLength={name === "name" ? 50 : name === "address" ? 100 : undefined}
               />
               {errors[name] && <div className="invalid-feedback">{errors[name]}</div>}
          </Form.Group>
     );

     // Render select fields
     const renderSelectField = (label, name, options) => (
          <Form.Group className="mb-3">
               <Form.Label>{label}</Form.Label>
               <Form.Select
                    name={name}
                    value={formData[name]}
                    onChange={handleChange}
                    disabled={isView}
                    className={errors[name] ? "is-invalid" : ""}
               >
                    <option value="">Select {label.toLowerCase()}</option>
                    {options.map((option) => (
                         <option key={option} value={option}>
                              {option}
                         </option>
                    ))}
               </Form.Select>
               {errors[name] && <div className="invalid-feedback">{errors[name]}</div>}
          </Form.Group>
     );

     // Render image field with preview
     const renderImageField = () => (
          <Form.Group className="mb-3">
               <Form.Label>Image</Form.Label>
               {isView ? (
                    <div>
                         <img
                              src={formData.image || "https://via.placeholder.com/150"}
                              alt="Collection"
                              className="img-fluid"
                              style={{ maxHeight: "200px", objectFit: "cover" }}
                         />
                    </div>
               ) : (
                    <>
                         <Form.Control
                              type="file"
                              accept="image/*"
                              onChange={handleImageChange}
                              className={errors.image ? "is-invalid" : ""}
                         />
                         {imagePreview && (
                              <div className="mt-10 w-100 d-flex justify-content-center align-items-center">
                                   <img
                                        src={imagePreview}
                                        alt="Preview"
                                        className="img-fluid"
                                        style={{ maxHeight: "200px", objectFit: "cover" }}
                                   />
                              </div>
                         )}
                         {errors.image && <div className="invalid-feedback">{errors.image}</div>}
                    </>
               )}
          </Form.Group>
     );

     return (
          <>
               {loading && <Loader />}
               <Modal
                    show={show}
                    onHide={() => {
                         handleClose();
                         setFormData(defaultCollection);
                         setErrors({});
                         setImagePreview(null);
                    }}
               >
                    <Modal.Header closeButton>
                         <Modal.Title>
                              {isCreate && "Create Collection"}
                              {isUpdate && "Update Collection"}
                              {isView && "View Collection"}
                         </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                         <Form>
                              {renderField("Name", "name")}
                              {renderField("Address", "address")}
                              {renderSelectField("Category", "category", CATEGORIES)}
                              {renderSelectField("Type", "type", TYPES)}
                              {renderImageField()}
                         </Form>
                    </Modal.Body>

                    <Modal.Body>
                         <div style={{ color: "red", fontSize: "12px" }}>
                              <div>* Only JPEG, JPG and PNG files are allowed</div>
                              <div>* Max File Size is 5 MB</div>
                         </div>
                    </Modal.Body>

                    <Modal.Footer>
                         <Button
                              variant="secondary"
                              onClick={() => {
                                   handleClose();
                                   setFormData(defaultCollection);
                                   setErrors({});
                                   setImagePreview(null);
                              }}
                         >
                              Close
                         </Button>
                         {!isView && (
                              <Button variant="primary" onClick={handleSubmit} disabled={loading || Object.keys(errors).length > 0}>
                                   {loading ? "Saving..." : isCreate ? "Create" : "Update"}
                              </Button>
                         )}
                    </Modal.Footer>
               </Modal>
          </>
     );
};

export default AddNftCollection;
